import * as types from "../actions/types";
/******************* 
@purpose : Intital home reducer data
@Author : INIC
******************/
const initialState = {
  categoryBannerInfo:{},
  categoryVehiclesData:[]
};

/******************* 
@purpose : Category Reducer
@Parameter : {ini_data, action}
@Author : INIC
******************/
export default function category(ini_data = initialState, action = {}) {
  switch (action.type) {
    // Set Various Custom Redux Key Data /
    case types.SET_CATEGORY_BANNER_INFO:
    return Object.assign({}, ini_data, {
      categoryBannerInfo: action.data,
    });
    case types.SET_CATEGORY_VEHICLE_DATA:
    return Object.assign({}, ini_data, {
      categoryVehiclesData: action.data,
    });
    
    default:
      return ini_data;
  }
}


